import api from 'services/api'

export const postConfirmUserNotification = async (body: { notificationId: string }) => {
  await api.post(`home-notificacao/confirmUserNotification`, { ...body }).catch((error) => {
    console.error(error)
  })
}

export const postMessageRead = async (body: { id_noti: number }) => {
  await api.post(`home-notificacao/messageRead`, { ...body }).catch((error) => {
    console.error(error)
  })
}

export const getListMessage = async () => {
  const returnApi = await api
    .get(`home-notificacao/listMessage`)
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}
